<template>
  <div class="warper w">
    <div class="warper_left">
      <div class="warper_left-logo">
        <img src="../../assets/image/logo.png" @click="goIndex" />
      </div>
      <!-- <div class="warper_left-addren">
        <i class="iconfont iconzuobiao" />
        <span class="city">成都</span>
        <i class="iconfont iconxiajiantou" />
      </div> -->
    </div>
    <div class="warper_right">
      <el-row :gutter="10">
        <el-col :span="4" v-for="(item, index) in menuListL" :key="item.id">
          <a
            href="javascript:void(0)"
            @click="changeColor(index, item.path,item.id)"
            :class="{ Selected: index == isShow }"
          >{{ item.authName }}</a>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { Alls } from "../../assets/js/global";
export default {
  data() {
    return {
      menuListL: Alls,
      isShow: 0
    };
  },
  created() {
    const index = sessionStorage.getItem("index");
    console.log(index);
    if (index && index.length !== 0) {
      this.isShow = index;
    }
  },
  methods: {
    changeColor(index, path,id) {
      if (path == "/forum") {
        sessionStorage.setItem("index", index);
        this.isShow = index;
        window.open("https://forum.jianchejia.cn/");
      } else {
        if(id == 3){
          let routeData = this.$router.resolve({
              path: path,
            });
            window.open(routeData.href, '_blank');
          }else{
 sessionStorage.setItem("index", index);
        this.isShow = index;
        this.$router.push(path);
          }
       
      }
    },
    goIndex() {
      this.$router.push("/");
      this.isShow = 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.warper {
  height: 100%;
  display: flex;
  justify-content: space-between;
  font-family: MicrosoftYaHei;
  .warper_left {
    width: 510px;
    height: 68px;
    display: flex;
    .warper_left-logo {
      width: 160px;
      height: 52px;
      cursor: pointer;
    }
    .warper_left-addren {
      margin: 22px 39px;
      color: white;
      .city {
        margin: 0 4px;
      }
      .iconzuobiao {
        width: 20px;
        height: 24px;
      }
      .iconxiajiantou {
        width: 10px;
        height: 6px;
      }
    }
  }
  .warper_right {
    width: 678px;
    height: 68px;
    a {
      color: white;
      font-size: 18px;
    }
  }
}
img {
  margin-top: 4px;
  width: 100%;
  height: 100%;
}
.Selected {
  color: #00a7ea !important;
  border-bottom: 1px solid #00a7ea;
}
</style>
